import { useGlobalStore } from "@/state/useGlobalStore";
import type {
  EditingFieldEntry,
  EditingFieldTableContext,
} from "@/state/@types";

const State = useGlobalStore;

export { State };
export type { EditingFieldEntry, EditingFieldTableContext };
